//本地环境添加 Auth 验证

function setAuth(){
    // let localPathArr = ['localhost','127.0.0.1','0.0.0.0'];
    // let hostname = location.hostname;
    // if(localPathArr.includes(hostname) && localStorage.token!='undefined'){
        window.axios.defaults.headers.common["Authorization"] = "Basic " + btoa(localStorage.token + ":" + "")
    //}
}

export default setAuth